import React from "react";
import { Button } from "@my-scoot/component-library-legacy";
import { useCustomColumnLockedModal } from "../CustomColumnLockedModal/utils/useCustomColumnLockedModal";
import { useAddCustomColumnModal } from "../AddCustomColumnModal/utils/useAddCustomColumnModal";
import { COMMON_WIDTH_RESOLUTIONS } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { getCrmAsset } from "features/Crm/utils/Crm.utils";
import { hasCreatorPermissions } from "utils/AuthUtil";
import { RESOURCE_KEYS } from "utils/OrgPermissions";

export const ManageColumnsModalFooter = ({ handleSubmit }) => {
  const hasCustomColumns = hasCreatorPermissions(
    RESOURCE_KEYS.SECTIONS.CUSTOM_COLUMNS
  );
  const { openCustomColumnLockedModal } = useCustomColumnLockedModal();
  const { openAddCustomColumnModal } = useAddCustomColumnModal();

  const onAddNewColumn = () => {
    if (!hasCustomColumns) openCustomColumnLockedModal();
    else openAddCustomColumnModal();
  };

  return (
    <div className="tw-flex tw-px-[18px] tw-pt-[12px] tw-pb-[24px] tw-pr-[24px] tw-justify-between tw-items-center tw-border-t-[2px] tw-border-solid tw-border-[#e7e6e4]">
      <div
        onClick={onAddNewColumn}
        className="tw-text-[#493ab1] tw-text-[16px] tw-font-medium tw-cursor-pointer tw-flex tw-items-center tw-gap-[8px]"
      >
        <ExlyImage
          src={getCrmAsset("add_column_right.svg")}
          height={20}
          width={20}
        />
        Add new column{" "}
        {!hasCustomColumns && (
          <ExlyImage
            className="tw-w-[56px] tw-h-[20px]"
            src={getCrmAsset("locked.svg")}
            fetchWidth={COMMON_WIDTH_RESOLUTIONS.WIDTH_360}
          />
        )}
      </div>
      <Button onClick={handleSubmit} size="medium" color="primary">
        Save
      </Button>
    </div>
  );
};
